<template>
  <v-text-field
      v-model.number="item"
      @change="onInput"
      v-bind="$attrs"
      dense
      outlined
      :filled="readonly"
      :readonly="readonly"
  >
  </v-text-field>
</template>

<script>
import commonFunction from "@/commonFunction/commonFunction"


export default {
  name: 'numberField',
  inheritAttrs: false,
  props: {
    value: {default: null},
    readonly: {type: [Boolean], default: false},
  },

  components: {},

  computed: {},

  watch: {
    value: {
      handler(newValue, oldValue) {
        // console.log('watch')
        this.item = newValue
      },
      deep: false
    },
  },

  methods: {
    onInput() {
      console.log('emitValue')
      // if (this.item === '' || typeof item.value !== 'number')
      //   this.item = null
      this.$emit('input', this.item)
    },
  },

  async mounted() {
    this.item = this.value
  },

  data() {
    return {
      item: null,
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
